export function getFormFromLocalStorage() {
  return JSON.parse(localStorage.getItem('form')) || {};
}